import dayjs from "dayjs";

export function convertWorkingDaysToArray(workingDaysObject) {
    return Object.entries(workingDaysObject.workingDays).map(([day, values]) => ({
        day: day,
        startTime: values.startTime ? dayjs(values.startTime).format("HH:mm") : null,
        endTime: values.endTime ? dayjs(values.endTime).format("HH:mm") : null,
        workingDay: Boolean(values.workingDay),
    }));
}

export function convertExistingWorkingDays(workingDaysObject) {
    return Object.entries(workingDaysObject.workingDays).map(([day, values]) => ({
        day: day,
        id: values.id,
        workingDay: Boolean(values.workingDay),
        workingTime: values.startTime.map((value, index) => ({
            startTime: value ? dayjs(value).format("HH:mm") : null,
            endTime: values.endTime[index] ? dayjs(values.endTime[index]).format("HH:mm") : null,
            appointmentsAtOnce: values.appointmentsAtOnce[index] ? values.appointmentsAtOnce[index] : 1
        }))
    }));
}

export const nonWorkingDaysFormat = "dd/MM/yyyy";

export function prepareDataForSubmittion(data) {
    const formattedData = convertExistingWorkingDays(data);

    // Create a set to keep track of existing non-working dates
    const existingNonWorkingDates = new Set(
        formattedData
            .filter(item => !item.isWorkingDay) // Filter only non-working days
            .map(item => item.date)
    );

    if (data?.NonWorkingDates?.length) {
        const nonWorkingDatesArray = data.NonWorkingDates
            .filter(item => item.date && !existingNonWorkingDates.has(dayjs(item.date).format("DD/MM/YYYY"))) // Filter out items without a date and duplicates
            .map(item => ({
                date: dayjs(item.date).format("DD/MM/YYYY"),
                isWorkingDay: false,
                id: item.id ? item.id : null,
            }));

        return [...formattedData, ...nonWorkingDatesArray];
    }

    return formattedData;
}



export const staticTableCell = [
    {
        align: 'left',
        title: 'DayOfTheWeek'
    },
    {
        align: 'center',
        title: 'StartTime'
    },
    {
        align: 'center',
        title: 'EndTime'
    },
    {
        align: 'center',
        title: 'WorkingDay'
    },
]